// Translation strings — French and English
export const STRINGS = {
    fr: {
        // Nav
        "nav.home": "Accueil",
        "nav.gates": "Portails",
        "nav.fences": "Clôtures",
        "nav.privacy_screen": "Brise-vue",
        "nav.motorization": "Motorisation",
        "nav.projects": "Réalisations",
        "nav.zones": "Zones",
        "nav.advice": "Conseils",
        "nav.contact": "Contact",
        // CTA
        "cta.quote": "Demander un devis",
        "cta.call": "Appeler maintenant",
        "cta.see_projects": "Voir nos réalisations",
        "cta.all": "Tout voir",
        "cta.contact_direct": "Contact direct",
        "cta.get_estimate": "Prêt à concrétiser votre projet ?",
        "cta.get_estimate_sub": "Devis gratuit, visite technique sur site et conseil personnalisé.",
        "cta.strip_label": "Devis & Conseil",
        // Header extra
        "header.tagline": "Genève · La Côte · Pays de Gex",
        // Hero
        "hero.tag": "Établi près de Genève · Léman",
        "hero.title_line1": "Portails, clôtures",
        "hero.title_line2": "et brise-vue",
        "hero.title_line3_a": "sur mesure",
        "hero.title_line3_b": "autour du Léman.",
        "hero.subtitle": "Installation, motorisation et solutions extérieures pour particuliers et professionnels, entre Genève, La Côte vaudoise, Haute-Savoie et Pays de Gex. Une approche artisanale, technique et élégante.",
        "hero.strip_installation": "Installation & pose",
        "hero.strip_motor": "Motorisation",
        "hero.strip_sub": "Nous posons vos portails — du conseil à la mise en service.",
        // About
        "about.tag": "À propos",
        "about.title_1": "L'élégance d'une entrée,",
        "about.title_2": "la sécurité d'une propriété.",
        "about.p1": "Portail du Léman accompagne les particuliers, professionnels, architectes, promoteurs et propriétaires exigeants dans la conception, la fourniture et la pose de portails, clôtures, brise-vue, motorisations et ouvrages de serrurerie-métallerie sur mesure.",
        "about.p2": "Basés à Saint-Jean-de-Gonville, à proximité immédiate de Genève, nous intervenons sur le bassin lémanique, en Suisse romande, sur Genève, La Côte vaudoise, le Pays de Gex et la Haute-Savoie.",
        "about.p3": "Chaque projet est étudié avec une approche technique, esthétique et durable. Notre objectif est de proposer des réalisations parfaitement intégrées à votre environnement extérieur, en associant sécurité, élégance, confort d'utilisation et qualité de finition.",
        "about.p4": "Nous réalisons des portails aluminium, portails acier, portails battants, portails coulissants, portillons, clôtures design, brise-vue extérieurs, claustras métalliques, motorisations de portail, automatismes, digicodes, interphones et solutions de contrôle d'accès.",
        "about.p5": "Notre savoir-faire s'étend également aux travaux de serrurerie et de métallerie sur mesure : garde-corps, rampes d'escalier, mains courantes, grilles de protection, structures métalliques, habillages extérieurs et aménagements métalliques pour villas, maisons contemporaines, immeubles, copropriétés et locaux professionnels.",
        "about.p6": "Portail du Léman privilégie des solutions robustes, soignées et intemporelles, pensées pour valoriser votre propriété tout en répondant aux contraintes techniques du terrain. Que votre projet concerne la sécurisation d'un accès, la modernisation d'une entrée, la création d'un espace plus intime ou la réalisation d'un ouvrage métallique sur mesure, nous vous accompagnons avec rigueur, conseil et exigence.",
        // Values
        "val.workshop": "Atelier local",
        "val.workshop_d": "Conception, fabrication et pose suivie depuis Saint-Jean-de-Gonville.",
        "val.custom": "Sur mesure & durable",
        "val.custom_d": "Aluminium thermolaqué, finitions premium pensées pour le climat du Léman.",
        "val.proximity": "Proximité Genève",
        "val.proximity_d": "Suivi de chantier réactif dans le Pays de Gex, Genève et la Haute-Savoie.",
        "val.aesthetics": "Esthétique technique",
        "val.aesthetics_d": "Une signature visuelle sobre, contemporaine et tenue dans le temps.",
        // Product tiles
        "tile.aluminium": "Portail aluminium",
        "tile.aluminium_tag": "Sur mesure",
        "tile.sliding": "Portail coulissant",
        "tile.sliding_tag": "Motorisable",
        "tile.fences": "Clôtures",
        "tile.fences_tag": "Aluminium · Rigide",
        "tile.privacy": "Brise-vue & Claustra",
        "tile.privacy_tag": "Design extérieur",
        "tile.install": "Installation & pose",
        "tile.install_tag": "Nous posons vos portails",
        "tile.motor": "Motorisation",
        "tile.motor_tag": "Digicode · Visiophone",
        // Sections
        "section.skills_tag": "Nos savoir-faire",
        "section.skills_title": "Conçus, fabriqués et posés autour du Léman",
        "section.zones_tag": "Zones d'intervention",
        "section.zones_title_1": "Une présence locale,",
        "section.zones_title_2": "de Genève à la Haute-Savoie.",
        "section.zones_sub": "Saint-Jean-de-Gonville, Gex, Ferney-Voltaire, Divonne-les-Bains, Saint-Genis-Pouilly, Annemasse, Genève, Nyon, La Côte vaudoise (Coppet, Gland, Rolle, Morges)…",
        "section.zones_btn": "Voir toutes les zones",
        // Contact page
        "contact.tag": "Contact & Devis",
        "contact.title": "Demandez votre devis.",
        "contact.intro": "Pour obtenir une première estimation, envoyez-nous quelques informations sur votre projet. Des photos de l'entrée, du terrain ou de la clôture existante permettent d'étudier plus rapidement la faisabilité.",
        "contact.field.name": "Nom*",
        "contact.field.name_ph": "Votre nom",
        "contact.field.phone": "Téléphone*",
        "contact.field.email": "Email",
        "contact.field.commune": "Commune",
        "contact.field.commune_ph": "Saint-Genis-Pouilly, Genève…",
        "contact.field.type": "Type de projet*",
        "contact.field.dims": "Dimensions approx.",
        "contact.field.dims_ph": "ex. 3,50 m de large",
        "contact.field.message": "Message / précisions",
        "contact.field.message_ph": "Décrivez votre projet, votre terrain, vos contraintes…",
        "contact.photos": "Photos (max 6)",
        "contact.photos_hint": "Cliquez pour ajouter des photos (JPG/PNG, 5 Mo max)",
        "contact.submit": "Envoyer ma demande",
        "contact.submitting": "Envoi…",
        "contact.submit_hint": "Votre demande est envoyée directement à info@portailduleman.com. Réponse sous 24-48h ouvrées.",
        "contact.success.title": "Merci, votre demande est enregistrée.",
        "contact.success.body": "Notre équipe vous recontacte sous 24 à 48 h ouvrées pour discuter de votre projet et planifier une visite technique.",
        "contact.success.again": "Nouvelle demande",
        "contact.aside.contact": "Contact direct",
        "contact.aside.deadlines": "Délais",
        "contact.aside.d1": "Réponse sous 24 à 48 h ouvrées",
        "contact.aside.d2": "Visite technique gratuite sur site",
        "contact.aside.d3": "Devis détaillé et sans engagement",
        "contact.aside.d4": "Suivi de chantier de proximité",
        "contact.err_required": "Merci de renseigner au moins votre nom, téléphone et le type de projet.",
        "contact.err_generic": "Une erreur est survenue. Merci de nous appeler directement.",
        "contact.success_toast": "Demande envoyée à info@portailduleman.com. Nous vous recontactons rapidement.",
        // Footer
        "footer.nav": "Navigation",
        "footer.zones": "Zones d'intervention",
        "footer.also": "Nous intervenons également à Thoiry, Prévessin-Moëns, Ornex, Cessy, Sergy, Crozet, Saint-Julien-en-Genevois, ainsi que sur toute La Côte vaudoise : Coppet, Nyon, Gland, Rolle, Morges.",
        "footer.mentions": "Mentions légales",
        "footer.privacy": "Confidentialité",
        // Product pages generic
        "product.characteristics": "Caractéristiques",
        "product.approach": "Notre approche",
        "product.keywords": "Mots-clés associés",
        "product.explore": "Explorer",
        "product.explore_title": "Autres solutions Portail du Léman",
        "product.visit_note": "Visite technique sur site gratuite — Saint-Jean-de-Gonville, Pays de Gex, Genève, Haute-Savoie.",
    },

    en: {
        // Nav
        "nav.home": "Home",
        "nav.gates": "Gates",
        "nav.fences": "Fences",
        "nav.privacy_screen": "Privacy screens",
        "nav.motorization": "Motorization",
        "nav.projects": "Projects",
        "nav.zones": "Areas",
        "nav.advice": "Advice",
        "nav.contact": "Contact",
        // CTA
        "cta.quote": "Request a quote",
        "cta.call": "Call now",
        "cta.see_projects": "See our projects",
        "cta.all": "See all",
        "cta.contact_direct": "Direct contact",
        "cta.get_estimate": "Ready to bring your project to life?",
        "cta.get_estimate_sub": "Free estimate, on-site technical visit and personalised advice.",
        "cta.strip_label": "Quote & advice",
        // Header extra
        "header.tagline": "Geneva · La Côte · Pays de Gex",
        // Hero
        "hero.tag": "Established near Geneva · Léman",
        "hero.title_line1": "Bespoke gates,",
        "hero.title_line2": "fences and privacy screens",
        "hero.title_line3_a": "custom-made",
        "hero.title_line3_b": "around Lake Geneva.",
        "hero.subtitle": "Installation, motorization and outdoor solutions for private and commercial clients across Geneva, La Côte, Haute-Savoie and Pays de Gex. A craftsman approach — technical and elegant.",
        "hero.strip_installation": "Installation & fitting",
        "hero.strip_motor": "Motorization",
        "hero.strip_sub": "We install your gates — from advice to commissioning.",
        // About
        "about.tag": "About us",
        "about.title_1": "The elegance of an entrance,",
        "about.title_2": "the security of a property.",
        "about.p1": "Portail du Léman supports private clients, professionals, architects, developers and demanding property owners in the design, supply and installation of bespoke gates, fences, privacy screens, motorization systems and custom metalwork.",
        "about.p2": "Based in Saint-Jean-de-Gonville, right next to Geneva, we work across the Lake Geneva basin, in French-speaking Switzerland, in Geneva, La Côte vaudoise, Pays de Gex and Haute-Savoie.",
        "about.p3": "Every project is studied with a technical, aesthetic and durable approach. Our goal is to deliver work that integrates perfectly into your outdoor environment, combining security, elegance, ease of use and quality of finish.",
        "about.p4": "We build aluminium gates, steel gates, swing gates, sliding gates, pedestrian gates, designer fences, outdoor privacy screens, metal claustras, gate motorization, automation, keypads, intercoms and access-control solutions.",
        "about.p5": "Our expertise also extends to custom locksmith and metalwork: guardrails, staircase railings, handrails, protective grilles, metal structures, exterior cladding and metal features for villas, contemporary homes, apartment buildings, co-owned properties and commercial premises.",
        "about.p6": "Portail du Léman favours robust, refined and timeless solutions, designed to enhance your property while addressing the technical constraints of the site. Whether your project involves securing an access, modernising an entrance, creating a more private space or building custom metalwork, we support you with rigour, advice and high standards.",
        // Values
        "val.workshop": "Local workshop",
        "val.workshop_d": "Design, fabrication and installation followed from Saint-Jean-de-Gonville.",
        "val.custom": "Bespoke & durable",
        "val.custom_d": "Powder-coated aluminium, premium finishes designed for the Léman climate.",
        "val.proximity": "Close to Geneva",
        "val.proximity_d": "Responsive on-site follow-up across Pays de Gex, Geneva and Haute-Savoie.",
        "val.aesthetics": "Technical aesthetics",
        "val.aesthetics_d": "A sober, contemporary visual signature built to last.",
        // Product tiles
        "tile.aluminium": "Aluminium gate",
        "tile.aluminium_tag": "Bespoke",
        "tile.sliding": "Sliding gate",
        "tile.sliding_tag": "Motorisable",
        "tile.fences": "Fences",
        "tile.fences_tag": "Aluminium · Rigid",
        "tile.privacy": "Privacy screens & Claustra",
        "tile.privacy_tag": "Outdoor design",
        "tile.install": "Installation & fitting",
        "tile.install_tag": "We install your gates",
        "tile.motor": "Motorization",
        "tile.motor_tag": "Keypad · Video intercom",
        // Sections
        "section.skills_tag": "Our expertise",
        "section.skills_title": "Designed, built and installed around Lake Geneva",
        "section.zones_tag": "Service areas",
        "section.zones_title_1": "A local presence,",
        "section.zones_title_2": "from Geneva to Haute-Savoie.",
        "section.zones_sub": "Saint-Jean-de-Gonville, Gex, Ferney-Voltaire, Divonne-les-Bains, Saint-Genis-Pouilly, Annemasse, Geneva, Nyon, La Côte vaudoise (Coppet, Gland, Rolle, Morges)…",
        "section.zones_btn": "See all areas",
        // Contact page
        "contact.tag": "Contact & Quote",
        "contact.title": "Request your quote.",
        "contact.intro": "For an initial estimate, send us a few details about your project. Photos of the entrance, the plot or the existing fence help us assess feasibility faster.",
        "contact.field.name": "Name*",
        "contact.field.name_ph": "Your name",
        "contact.field.phone": "Phone*",
        "contact.field.email": "Email",
        "contact.field.commune": "Town / City",
        "contact.field.commune_ph": "Saint-Genis-Pouilly, Geneva…",
        "contact.field.type": "Project type*",
        "contact.field.dims": "Approx. dimensions",
        "contact.field.dims_ph": "e.g. 3.50 m wide",
        "contact.field.message": "Message / details",
        "contact.field.message_ph": "Describe your project, your site, any constraints…",
        "contact.photos": "Photos (max 6)",
        "contact.photos_hint": "Click to add photos (JPG/PNG, max 5 MB)",
        "contact.submit": "Send my request",
        "contact.submitting": "Sending…",
        "contact.submit_hint": "Your request goes directly to info@portailduleman.com. Reply within 24–48 business hours.",
        "contact.success.title": "Thank you — your request has been received.",
        "contact.success.body": "Our team will get back to you within 24 to 48 business hours to discuss your project and schedule a technical visit.",
        "contact.success.again": "New request",
        "contact.aside.contact": "Direct contact",
        "contact.aside.deadlines": "What to expect",
        "contact.aside.d1": "Reply within 24 to 48 business hours",
        "contact.aside.d2": "Free on-site technical visit",
        "contact.aside.d3": "Detailed quote, no obligation",
        "contact.aside.d4": "Close, local project follow-up",
        "contact.err_required": "Please provide at least your name, phone number and project type.",
        "contact.err_generic": "Something went wrong. Please call us directly.",
        "contact.success_toast": "Request sent to info@portailduleman.com. We'll get back to you shortly.",
        // Footer
        "footer.nav": "Navigation",
        "footer.zones": "Service areas",
        "footer.also": "We also work in Thoiry, Prévessin-Moëns, Ornex, Cessy, Sergy, Crozet, Saint-Julien-en-Genevois, and throughout La Côte vaudoise: Coppet, Nyon, Gland, Rolle, Morges.",
        "footer.mentions": "Legal notice",
        "footer.privacy": "Privacy",
        // Product pages generic
        "product.characteristics": "Features",
        "product.approach": "Our approach",
        "product.keywords": "Related keywords",
        "product.explore": "Explore",
        "product.explore_title": "Other Portail du Léman solutions",
        "product.visit_note": "Free on-site technical visit — Saint-Jean-de-Gonville, Pays de Gex, Geneva, Haute-Savoie.",
    },
};
